import { NgModule } from "@angular/core";
import { DeepSearchPipe } from "./deep-search.pipe";

@NgModule({
    declarations: [DeepSearchPipe],
    exports: [DeepSearchPipe]
})
export class CommonPipesModule {}


// WEBPACK FOOTER //
// ./src/pipes/common-pipes.module.ts